import { FormValues, WidthAndSizeFormValues } from "../types/form";

export const defaultWidthAndSizeFormValues: WidthAndSizeFormValues = {
  leftWidth: "",
  leftSize: "",
  rightWidth: "",
  rightSize: "",
};

export const defaultFormValues: FormValues = {
  color: "",
  widthAndSize: defaultWidthAndSizeFormValues,
  isConsented: {
    isConsented: false,
    isConsented2: false,
  },
};
